exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".stepFormText[data-v-5a0f88c6] {\n  margin-bottom: 24px;\n}\n.ant-form-item-label[data-v-5a0f88c6],\n.ant-form-item-control[data-v-5a0f88c6] {\n  line-height: 22px;\n}\n", ""]);

// exports
